'use client';

import { useState, useCallback } from 'react';
import { useRouter } from 'next/navigation';

export default function LoginPage() {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const router = useRouter();

  const handleSubmit = useCallback(async (e: React.FormEvent) => {
    e.preventDefault();
    if (!password.trim()) return;
    setLoading(true);
    setError('');

    try {
      const res = await fetch('/api/auth/verify', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password }),
      });

      if (res.ok) {
        router.push('/pm-live');
        router.refresh();
      } else {
        const data = await res.json();
        setError(data.error || 'Invalid password');
        setPassword('');
      }
    } catch {
      setError('Connection failed');
    } finally {
      setLoading(false);
    }
  }, [password, router]);

  return (
    <div style={{
      minHeight: '100vh',
      background: '#0a0a0a',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontFamily: 'system-ui, -apple-system, sans-serif',
    }}>
      <div style={{
        width: 340,
        padding: 32,
        background: '#111',
        borderRadius: 12,
        border: '1px solid #2a2a2a',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 28 }}>
          <span style={{ fontSize: 28 }}>\u26A1</span>
          <h1 style={{ color: '#fff', fontSize: 18, fontWeight: 700, marginTop: 8, letterSpacing: '-0.02em' }}>Hub Dashboard</h1>
          <p style={{ color: '#555', fontSize: 12, marginTop: 4 }}>Enter password to continue</p>
        </div>

        <form onSubmit={handleSubmit}>
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder="Password"
            autoFocus
            style={{
              width: '100%',
              padding: '10px 14px',
              background: '#1a1a1a',
              border: error ? '1px solid #ff4444' : '1px solid #2a2a2a',
              borderRadius: 8,
              color: '#fff',
              fontSize: 14,
              outline: 'none',
              boxSizing: 'border-box',
            }}
          />
          {error && (
            <p style={{ color: '#ff4444', fontSize: 12, marginTop: 8 }}>{error}</p>
          )}
          <button
            type="submit"
            disabled={loading || !password.trim()}
            style={{
              width: '100%',
              padding: '10px 0',
              marginTop: 16,
              background: loading ? '#333' : '#fff',
              color: '#000',
              border: 'none',
              borderRadius: 8,
              fontSize: 14,
              fontWeight: 600,
              cursor: loading ? 'wait' : 'pointer',
              opacity: !password.trim() ? 0.4 : 1,
            }}
          >
            {loading ? '...' : 'Enter'}
          </button>
        </form>

        <p style={{ color: '#333', fontSize: 10, textAlign: 'center', marginTop: 20 }}>
          Session expires after 6 hours
        </p>
      </div>
    </div>
  );
}
